import CryptoJS from 'crypto-js';
import io from 'socket.io-client';
import xss from 'xss';
import { ajax } from './ec-ajax';
import { openDialog } from './ec-popup';

//-----------------------------------------------------------------------------
// Consts
//-----------------------------------------------------------------------------

// const KEY = 'f53c50e4ab798944a4debe137ec8ba677dbf44ebd37e373f785bf59a8c048c54';
// const KEY_128 = KEY.substring(0, 128 / 8);
// const KEY_256 = KEY.substring(0, 256 / 8);
// const HEX_KEY_128 = CryptoJS.enc.Latin1.parse(KEY_128);
// const HEX_KEY_256 = CryptoJS.enc.Latin1.parse(KEY_256);
// const HEX_IV = CryptoJS.enc.Latin1.parse(KEY_128);

//-----------------------------------------------------------------------------
// Functions
//-----------------------------------------------------------------------------

/**
 * Message Push Server에 접속합니다.
 */
function connectToPushServer() {
    if (!_.has(window, 'USER_ID')) {
        throw new Error('Cannot connect to pushserver cause there is no USER_ID.');
    }

    const pushServerHost = GFN_CONTEXT_INFO['pushserver.host'];
    const pushServerPort = GFN_CONTEXT_INFO['pushserver.port'];
    if (!_.isEmpty(pushServerHost)) {
        let connectString = pushServerHost;
        if (!_.isEmpty(pushServerPort)) {
            connectString += `:${pushServerPort}`;

            const userId = window.USER_ID;
            const socket = io(connectString, {
                reconnection: true,
                reconnectionAttempts: 5,
                reconnectionDelay: 3,
            });

            socket.on('connect', () => {
                socket.emit('register', userId);
            });

            // socket.on('notify', (notify) => {
            //     if (notify && notify.userId === userId) {
            //
            //     }
            // });

            socket.on('message', (message) => {
                if (message && message.userId === userId) {
                    openDialog('message', message.content);
                    socket.emit('ack', message.messageId);
                }
            });
        }
    }
}

/**
 * Grid 컬럼 정보에서 Field와 관련된 데이터를 추출합니다.
 * @param  {Object} column Grid 컬럼 정보
 * @return {Object}        필드 정보
 */
function extractFieldAttr(column) {
    const FIELD_ATTR = [
        'fieldName', 'dataType', 'subtype', 'subTypeEnabled',
        'min', 'minimum', 'max', 'maximum',
        'set', 'length', 'baseField', 'header',
        'defaultValue', 'required', 'updatable', 'booleanFormat',
        'datetimeFormat', 'amText', 'pmText', 'baseYear',
        'calculateCallback', 'comparer',
    ];
    const field = {};
    $(FIELD_ATTR).each((i, attr) => {
        if (_.has(column, attr)) {
            field[attr] = column[attr];
        }
    });
    return field;
}

function filterXSS(value) {
    return xss(value);
}

function getDefaultFormSetting(programId, gridId, columnSet = undefined) {
    const param = {
        programId,
        gridId,
    };

    if (columnSet) {
        param.columnSet = columnSet;
    }

    const getDefaultFormSet = () => {
        let userGridFrmSeq = null;
        ajax({
            url: `${GFN_CONTEXT_INFO['server.context']}/common/func/getDefaultFormSet.dev`,
            data: {
                IN_PARAM: param,
            },
            success: (data) => {
                if (!_.isEmpty(data.OUT_DS) && _.has(data.OUT_DS, 'userGridFrmSeq')) {
                    userGridFrmSeq = data.OUT_DS.userGridFrmSeq;
                }
            },
        });
        return userGridFrmSeq;
    };

    const getFormSetColumns = () => {
        const userGridFrmSeq = getDefaultFormSet();
        let columns = null;

        if (!_.isEmpty(userGridFrmSeq)) {
            param.userGridFrmSeq = userGridFrmSeq;
            ajax({
                url: `${GFN_CONTEXT_INFO['server.context']}/common/func/getFormSetColumns.dev`,
                data: {
                    IN_PARAM: param,
                },
                success: (data) => {
                    columns = _.get(data, 'OUT_DS');
                },
            });
        }
        return columns;
    };

    let defaultColumns = null;
    const formSetColumns = getFormSetColumns();
    if (_.isArray(formSetColumns)) {
        ajax({
            url: `${GFN_CONTEXT_INFO['server.context']}/common/func/getGridColumns.dev`,
            data: {
                IN_PARAM: param,
            },
            success: (data) => {
                const columns = _.get(data, 'OUT_DS');
                if (_.isArray(columns)) {
                    const newColumns = [];
                    const fixedColumns = [];

                    formSetColumns.forEach((fsc) => {
                        for (let i = 0; i < columns.length; i += 1) {
                            const column = columns[i];
                            if (_.isEqual(fsc.colId, column.name)) {
                                if (_.isEqual(fsc.fixYn, 'Y') && (_.isEqual(column.visible, undefined) || _.isEqual(column.visible, true))) {
                                    fixedColumns.push(columns.splice(i, 1)[0]);
                                } else {
                                    newColumns.push(columns.splice(i, 1)[0]);
                                }
                            }
                        }
                    });

                    columns.forEach((column) => {
                        const col = column;
                        col.visible = false;
                    });

                    defaultColumns = {
                        fixedColumns,
                        columns: fixedColumns.concat(newColumns, columns),
                    };
                }
            },
        });
    }

    return defaultColumns;
}

/**
 * Grid JSON 컬럼정보를 가져옵니다. 다국어처리를 하지 않습니다.
 * @param  {String} url                                JSON 컬럼정보 URL.
 * @param  {RealGridJS.GridView} gridView              컬럼을 적용 할 GridView.
 * @param  {RealGridJS.LocalDataProvider} dataProvider 필드를 적용 할 DataProvider
 */
function getGridColumns(url, gridView, dataProvider) {
    $.ajax({
        url,
        contentType: 'application/json',
        dataType: 'json',
        data: {},
        async: false,
        success(data) {
            const columns = _.get(data, 'columns');
            gridView.setColumns(columns);

            const fields = [];
            $(columns).each((i, column) => {
                const columnType = _.get(column, 'type');

                if (_.isEqual(columnType, 'group')) {
                    const childColumns = _.get(column, 'columns');
                    if (_.isArray(childColumns)) {
                        $(childColumns).each((j, childColumn) => {
                            fields.push(extractFieldAttr(childColumn));
                        });
                    }
                } else {
                    fields.push(extractFieldAttr(column));
                }
            });
            dataProvider.setFields(fields);
        },
    });
}

/**
 * GET 방식으로 전달된 인자들을 가져옵니다.
 * @return {Object} 인자 객체
 */
function getRequestParameters() {
    let search = location.search;
    const parameters = {};

    if (search.indexOf('?') > -1) {
        search = search.split('?')[1].split('&');

        $(search).each((i) => {
            const p = search[i];
            const keyValue = p.split('=');
            const decValue = _.isEmpty(keyValue[1]) ? '' : decodeURIComponent(keyValue[1]);
            parameters[keyValue[0]] = decValue;
        });
    }

    return parameters;
}

/**
 * 세션에서 사용자 지정 날짜 형식을 가져옵니다.
 * @return {String} 날짜 형식
 */
function getUserDateFormat() {
    let f = null;
    let userDateFormat = null;
    if (_.isEqual(GFN_CONTEXT_INFO['server.context'], '/sample')) {
        /* eslint no-underscore-dangle:off */
        userDateFormat = session_user._USER_DATE_FORMAT;
        if (_.isEqual(userDateFormat, 'YYYY-MM-DD')) {
            f = 'yyyy-MM-dd';
        } else if (_.isEqual(userDateFormat, 'MM-DD-YYYY')) {
            f = 'MM-dd-yyyy';
        } else if (_.isEqual(userDateFormat, 'DD-MM-YYYY')) {
            f = 'dd-MM-yyyy';
        }
    } else {
        /* eslint no-underscore-dangle:off */
        /* global _USER_DATE_FORMAT */
        userDateFormat = _USER_DATE_FORMAT;
        if (_.isEqual(userDateFormat, 'YYYY-MM-DD')) {
            f = 'yyyy-MM-dd';
        } else if (_.isEqual(userDateFormat, 'MM-DD-YYYY')) {
            f = 'MM-dd-yyyy';
        } else if (_.isEqual(userDateFormat, 'DD-MM-YYYY')) {
            f = 'dd-MM-yyyy';
        }
    }
    return f;
}

/**
 * 세션에서 사용자 지정 숫자 형식을 가져옵니다.
 * @return {String} 숫자 형식
 */
function getUserNumberFormat() {
    let f = null;
    let userNumberFormat = null;
    if (_.isEqual(GFN_CONTEXT_INFO['server.context'], '/sample')) {
        /* eslint no-underscore-dangle:off */
        userNumberFormat = session_user._USER_NUM_FRM_CD;
        if (_.isEqual(userNumberFormat, '#,###.##')) {
            f = '#,##0.##';
        } else if (_.isEqual(userNumberFormat, '#,###.##')) {
            f = '#,##0.##;,;.';
        }
    } else {
        /* eslint no-underscore-dangle:off */
        /* global _USER_NUM_FRM_CD */
        userNumberFormat = _USER_NUM_FRM_CD;
        if (_.isEqual(userNumberFormat, '#,###.##')) {
            f = '#,##0.##';
        } else if (_.isEqual(userNumberFormat, '#,###.##')) {
            f = '#,##0.##;,;.';
        }
    }
    return f;
}

/**
 * 컨텍스트를 포함하는 Web Application Root 경로를 가져옵니다.
 * @return {String} WebAppRoot + ContextRoot 경로
 */
function getWebAppPath() {
    const port = (!location.port || location.port === '80') ? '' : `:${location.port}`;
    const contextRoot = _.has(GFN_CONTEXT_INFO, 'server.context') ? GFN_CONTEXT_INFO['server.context'] : '';
    return `${location.protocol}//${location.hostname}${port}${contextRoot}`;
}

/**
 * 접속한 브라우저가 모바일 브라우저인지 확인합니다.
 * @return {Boolean} true일 때 접속한 브라우저는 모바일 브라우저입니다
 */
function isMobile() {
    return navigator.userAgent.indexOf('Mobi') > -1;
}

/**
 * 제공 된 값이 null, NaN 또는 비어있는 값인지 확인합니다.
 * @param  {Object}  value 확인할 값
 * @return {Boolean}       값이 null, NaN 또는 비어있다면 true입니다
 */
function isNull(value) {
    return _.isNull(value) || _.isNaN(value) || _.isEmpty(value);
}

/**
 * 제공 된 값이 배열인지 확인합니다.
 * @param  {Object}  value 확인할 값
 * @return {Boolean}       값이 배열이라면 true입니다
 */
function isArray(value) {
    return _.isArray(value);
}

/**
 * 제공 된 값이 Boolean값인지 확인합니다.
 * @param  {Object}  value 확인할 값
 * @return {Boolean}       값이 Boolean값이라면 true입니다
 */
function isBoolean(value) {
    return _.isBoolean(value);
}

/**
 * 제공 된 값이 정수값인지 확인합니다.
 * @param  {Object}  value 확인할 값
 * @return {Boolean}       값이 정수값이라면 true입니다
 */
function isInteger(value) {
    return _.isInteger(value);
}

/**
 * 제공 된 값이 실수값인지 확인합니다.
 * @param  {Object}  value 확인할 값
 * @return {Boolean}       값이 실수값이라면 true입니다
 */
function isNumber(value) {
    return _.isNumber(value);
}

/**
 * 제공 된 값이 문자열인지 확인합니다.
 * @param  {Object}  value 확인할 값
 * @return {Boolean}       값이 문자열이라면 true입니다
 */
function isString(value) {
    return _.isString(value);
}

/**
 * 제공 된 두 값이 같은지 확인합니다.
 * @param  {Object}  source 비교값
 * @param  {Object}  target 대상값
 * @return {Boolean}        값이 같다면 true입니다
 */
function isEqual(source, target) {
    return _.isEqual(source, target);
}

/**
 * Grid Export 설정 팝업을 생성합니다.
 * @param  {Function} closeHandler          팝업을 닫을 때, 데이터를 처리하기 위한 이벤트 핸들러.
 */
function openGridExportSettingPopup(closeHandler = undefined) {
    const url = `${GFN_CONTEXT_INFO['server.context']}/cmn/popup/GridExportSettingPopup.do`;
    const p = {
        size_width: 340,
        size_height: 200,
    };
    top.window.com.pantos.ec.utils.PopupUtil.openPopup('gridExportSettingPopup', url, p, closeHandler);
}

/**
 * Grid 컬럼 개인화 설정 팝업을 생성합니다.
 * @param  {String}   programId             업무패키지 및 하위 경로를 포함하는 프로그램 ID.
 * @param  {String}   gridId                Grid ID.
 * @param  {String}   [columnSet=undefined] 여러 개의 컬럼 정보를 가졌을 경우, ColumnSet을 통해 구분합니다.
 * @param  {Function} closeHandler          팝업을 닫을 때, 데이터를 처리하기 위한 이벤트 핸들러.
 */
function openGridFormSettingPopup(programId, gridId, columnSet = undefined, closeHandler = undefined) {
    const url = `${GFN_CONTEXT_INFO['server.context']}/cmn/popup/GridFormSettingPopup.do`;
    const p = {
        programId,
        gridId,
        size_width: 780,
        size_height: 620,
    };

    if (!_.isEmpty(columnSet)) {
        p.columnSet = columnSet;
    }

    top.window.com.pantos.ec.utils.PopupUtil.openPopup('gridFormSettingPopup', url, p, closeHandler);
}

/**
 * 로딩화면을 표시합니다.
 */
function showLoading() {
    if (!_.has(window, 'layerLoading')) {
        const $element = $(window.document).find('#LAYER_LOADING');
        if (!$element.length) {
            $(window.document).find('body').append('<div id="LAYER_LOADING" class="pop-loading"><p>loading..</p><div>');
        }

        const option = {};
        option.class_overlay = isMobile() ? 'modal-overlay' : 'modal-overlay2';
        if (isMobile()) {
            option.drag_flag = false;
        }

        window.layerLoading = $plugin.popmodal($(window.document).find('#LAYER_LOADING'), option);
        $element.dblclick(() => window.layerLoading.closeOutput());
    }

    window.layerLoading.openOutput();
}

/**
 * 로딩화면을 숨깁니다.
 */
function hideLoading() {
    if (_.has(window, 'layerLoading')) {
        window.layerLoading.closeOutput();
    }
}

//-----------------------------------------------------------------------------
// Crypto
//-----------------------------------------------------------------------------

// function encryptAES128(value) {
//     const encrypted = CryptoJS.AES.encrypt(value, HEX_KEY_128, { iv: HEX_IV });
//     const result = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
//     return result;
// }
//
// function decryptAES128(value) {
//     const decrypted = CryptoJS.AES.decrypt(value, HEX_KEY_128, { iv: HEX_IV });
//     const result = decrypted.toString(CryptoJS.enc.Utf8);
//     return result;
// }
//
// function encryptAES256(value) {
//     const encrypted = CryptoJS.AES.encrypt(value, HEX_KEY_256, { iv: HEX_IV });
//     const result = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
//     return result;
// }
//
// function decryptAES256(value) {
//     const decrypted = CryptoJS.AES.decrypt(value, HEX_KEY_256, { iv: HEX_IV });
//     const result = decrypted.toString(CryptoJS.enc.Utf8);
//     return result;
// }

/**
 * 제공 된 값을 SHA-128(SHA-1) 방식으로 해싱합니다.
 * @param  {Object} value 해싱할 대상값
 * @return {String}       해싱한 값
 */
function encryptSHA128(value) {
    const encrypted = CryptoJS.SHA1(value);
    return encrypted.toString(CryptoJS.enc.Base64);
}

/**
 * 제공 된 값을 SHA-256 방식으로 해싱합니다.
 * @param  {Object} value 해싱할 대상값
 * @return {String}       해싱한 값
 */
function encryptSHA256(value) {
    const encrypted = CryptoJS.SHA256(value);
    return encrypted.toString(CryptoJS.enc.Base64);
}

export {
    connectToPushServer,
    extractFieldAttr,
    filterXSS,
    getDefaultFormSetting,
    getGridColumns,
    getRequestParameters,
    getUserDateFormat,
    getUserNumberFormat,
    getWebAppPath,
    isMobile,
    isNull,
    isArray,
    isBoolean,
    isInteger,
    isNumber,
    isString,
    isEqual,
    openGridExportSettingPopup,
    openGridFormSettingPopup,
    showLoading,
    hideLoading,
    // encryptAES128,
    // decryptAES128,
    // encryptAES256,
    // decryptAES256,
    encryptSHA128,
    encryptSHA256,
};



// WEBPACK FOOTER //
// ./src/utils/ec-common.js